import { useAppSelector } from "@store/store-helper";
import { getSnapshotByIdSelector } from "@store/projects/projects-selector";
import { ListItemText } from "@mui/material";
import { FetchingItem } from "@store/table/table-slice-helper";
import { defaultProjectThumbnail } from "@utils/project-utils";

interface Props {
  /** The unique ID of the item that is being requested to do action on */
  item: FetchingItem;
}

/** List item in bulk action dialog for snapshots */
export function SnapshotListContent({ item }: Props): JSX.Element | null {
  const selectedSnapshot = useAppSelector(getSnapshotByIdSelector(item.id));

  if (selectedSnapshot === null) {
    return null;
  }

  return (
    <>
      <img
        src={selectedSnapshot.thumbnailUrl ?? defaultProjectThumbnail}
        style={{
          height: "40px",
          width: "56px",
          maxHeight: "100%",
          maxWidth: "100%",
          objectFit: "contain",
          borderRadius: "8px",
        }}
        alt="Snapshot thumbnail"
      />

      <ListItemText primary={<var>{selectedSnapshot.name}</var>} />
    </>
  );
}
